import React, { Component } from 'react';
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import './loader-style.scss'

class LoaderComponent extends Component {
    render() {
        return (
            <div className="loader-container"
                // style={{
                //     width: "100%",
                //     height: "100",
                //     display: "flex",
                //     justifyContent: "center",
                //     alignItems: "center"
                // }}
            >
                <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height={100}
                    width={100}
                />
            </div>

        )
    }
}

export default LoaderComponent;